export default {
  "agentReport.title": "Agent Approval",
  "agentReport.thead.index": "#No",
  "agentReport.thead.statisticsTime": "StatisticsTime",
  "agentReport.thead.statisticsTimezone": "StatisticsTimezone",
  "agentReport.thead.agentInviteNum": "AgentInviteNum",
  "agentReport.thead.agentInviteBet": "AgentInviteBet",
  "agentReport.thead.agentInviteBonus": "AgentInviteBonus",
};
